// What happens after paying, as dated steps - used under each delivery
// option and on the thank-you page. `when` is a date or a moment ("Today",
// "On the day"), `what` is what happens then.
function Timeline({ items }) {
  return (
    <ol className="of-timeline">
      {items.map((item, i) => (
        <li key={i}>
          <span className="of-timeline-when">{item.when}</span>
          <span className="of-timeline-what">{item.what}</span>
        </li>
      ))}
    </ol>
  );
}

export default Timeline;
